module.exports = __webpack_public_path__ + "static/media/how-it-works-image-1-2.25c5d923.png";